import React from 'react';

import './style.css';

const PaginationContainer = ({ children }) => {
  return <div className="main-container-pagination">{children}</div>;
};

export default PaginationContainer;
